import React from 'react'
import './../App.css'
import api from './api.js'
import logo from './../imgs/home_nav_logo.svg'
import logo1 from './../imgs/home_nav_logo_black.svg'
import common_data from './../api/common_data.js'
import icon_home_call from './../imgs/icon_home_call.png'
import icon_home_call_s from './../imgs/icon_home_call_s.png'
import icon_home_message_n from './../imgs/icon_home_message_n.png'
import icon_home_message_s from './../imgs/icon_home_message_s.png'
import icon_home_top from './../imgs/icon_home_top.png'
import icon_home_top_s from './../imgs/icon_home_top_s.png'
export default class Common extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            hover_flag: false,
            show_bg_flag: false,
            top_hover: false,
            call_hover: false,
            email_hover: false,
        }
    }
    //滚动效果
    animateScroll = (element, speed) => {
        let rect = element.getBoundingClientRect();
        //获取元素相对窗口的top值，此处应加上窗口本身的偏移
        let top = window.pageYOffset + rect.top-100;
        console.log(rect.top, top)
        let currentTop = 0;
        let requestId;
        //采用requestAnimationFrame，平滑动画
        function step(timestamp) {
            currentTop += speed;
            if (currentTop <= top) {
                window.scrollTo(0, currentTop);
                requestId = window.requestAnimationFrame(step);
            } else {
                window.cancelAnimationFrame(requestId);
            }
        }
        window.requestAnimationFrame(step);
    }
    componentDidMount() {
        if (!sessionStorage.getItem('get_top_product')) {
            api.get_top_product({}).then(res => {
                console.log(res);
                if (res.code === 0) {
                    this.setState({ list: res.content || [] })
                    sessionStorage.setItem('get_top_product', JSON.stringify(res.content))
                }
            })
        } else {
            this.setState({ list: JSON.parse(sessionStorage.getItem('get_top_product')) || [] })
        }
        if (!sessionStorage.getItem('get_top_openPlatform')) {
            api.get_top_openPlatform({}).then(res => {
                console.log(res);
                if (res.code === 0) {
                    this.get_top_openPlatform = res.content.redirect_uri;
                    sessionStorage.setItem('get_top_openPlatform', JSON.stringify(res.content))
                }
            })
        } else {
            this.get_top_openPlatform = JSON.parse(sessionStorage.getItem('get_top_openPlatform')).redirect_uri;
        }
        //get_top_customerCase
        // if (!sessionStorage.getItem('get_top_customerCase')) {
        //     api.get_top_customerCase({}).then(res => {
        //         console.log(res);
        //         if (res.code === 0) {
        //             this.get_top_customerCase=res.content.redirect_uri;
        //             sessionStorage.setItem('get_top_customerCase', JSON.stringify(res.content))
        //         }
        //     })
        // } else {
        //     this.get_top_customerCase=JSON.parse(sessionStorage.getItem('get_top_customerCase'));
        // }
        //获取banner
        if (!sessionStorage.getItem('get_home_banner')) {
            api.get_home_banner({}).then(res => {
                console.log(res);
                if (res.code === 0) {
                    this.get_home_banner = res.content;
                    sessionStorage.setItem('get_home_banner', JSON.stringify(res.content))
                }
            })
        } else {
            this.get_home_banner = JSON.parse(sessionStorage.getItem('get_home_banner'));
        }




        window.onscroll = e => {
            //console.log(e.target.scrollTop)
            var t = document.documentElement.scrollTop || document.body.scrollTop;
            //console.log(t);
            if (t > 400) {
                this.setState({ show_bg_flag: true });
            } else {
                this.setState({ show_bg_flag: false });
            }
        }
    }
    render() {
        return (<div className={`top main 
        ${this.state.hover_flag ? 'show' : ''} 
        ${this.state.show_bg_flag ? 'show' : ''}`}
            onMouseLeave={() => {
                this.setState({ hover_flag: false })
            }}>

            <div className="w" >
                {/* ces  */}
                <div className="logo" onClick={() => {
                    //window.location.href = window.location.origin + '/#/'
                    this.props.history.push({ pathname: '/' })
                }}>
                    {((this.props.history.location.pathname === '/login' || this.props.history.location.pathname === '/register') && !this.state.hover_flag) ? <img src={logo1} width='180px' alt="" /> : <img src={logo} width='180px' alt="" />}

                </div>
                <ul className={`button ${(this.props.history.location.pathname === '/login' || this.props.history.location.pathname === '/register') ? 'active' : ''}`} >
                    <li onClick={() => {
                        this.props.history.push({ pathname: '/' })
                    }} className={`first ${this.state.hover_flag ? 'show' : ''}`}
                        onMouseEnter={() => {
                            this.setState({ hover_flag: true })
                        }} >
                            {/* <span>产品</span> */}
                        <ul>
                            <div>
                                {this.state.list.map((v, i) => {
                                    return (<li key={i}>
                                        <span>{v.category_name}</span>
                                        <ol>
                                            {(v.products || []).map((vv, ii) => {
                                                return (<li key={ii} onClick={()=>{
                                                    //console.log(vv)
                                                    if(vv.id===21){
                                                       console.log(api.base+'/#/menjin')
                                                       window.location.href=api.base+'/#/menjin';
                                                    }
                                                }}>
                                                    {/* <a href={vv.redirect_uri}>{vv.name}</a> */}
                                                    <span >{vv.name}</span>
                                                </li>)
                                            })}
                                        </ol>
                                    </li>)
                                })}
                            </div>
                        </ul>


                    </li>
                    <li onClick={() => {
                        
                        this.props.history.push({ pathname: '/solve_plan' })
                        // if (this.props.history.location.pathname === '/') {
                        //     this.animateScroll(common_data.refs.product, 20)
                        // }
                    }}><span>行业解决方案</span></li>
                    <li onClick={() => {

                        if (this.props.history.location.pathname === '/') {
                            this.animateScroll(common_data.refs.partner, 30)
                        } else {
                            this.props.history.push({ pathname: '/' })
                            setTimeout(() => {
                                this.animateScroll(common_data.refs.partner, 30)
                            }, 200)
                        }
                    }}><span>客户案例</span></li>
                    <li onClick={() => {
                        console.log(this.get_top_openPlatform)
                        window.location.href = this.get_top_openPlatform;
                    }}><span>开放平台</span></li>
                    <li onClick={() => {
                        if (this.props.history.location.pathname === '/') {
                            //console.log(window.screenTop)
                            this.animateScroll(common_data.refs.partner, 50)
                        } else {
                            this.props.history.push({ pathname: '/' })
                            setTimeout(() => {
                                this.animateScroll(common_data.refs.partner, 50)
                            }, 200)
                        }
                        
                    }}><span>合作伙伴</span></li>
                    <li onClick={() => {
                        this.props.history.push({ pathname: '/download' })
                    }}><span>下载</span></li>
                </ul>
                <div className="right">
                    <div
                        className={`button ${(this.props.history.location.pathname === '/login' || this.props.history.location.pathname === '/register') ? 'active' : ''}`}
                        onClick={() => {
                            this.props.history.push({ pathname: '/register' })
                        }}>注册</div>
                    <div
                        className={`button grost ${(this.props.history.location.pathname === '/login' || this.props.history.location.pathname === '/register') ? 'active' : ''}`}
                        onClick={() => {
                            this.props.history.push({ pathname: '/login' })
                        }}>企业登录</div>
                </div>
            </div>
            <div className="link">
                <ul>
                    <li onMouseEnter={() => {
                        this.setState({ top_hover: true })
                    }} onMouseLeave={() => {
                        this.setState({ top_hover: false })
                    }} onClick={() => {
                        var currentTop = window.pageYOffset, top = 0, requestId;
                        function step(timestamp) {
                            currentTop -= 40;
                            if (currentTop >= top) {
                                window.scrollTo(0, currentTop);
                                requestId = window.requestAnimationFrame(step);
                            } else {
                                window.cancelAnimationFrame(requestId);
                            }
                        }
                        window.requestAnimationFrame(step);
                    }}>
                        <span>

                            {this.state.top_hover ?
                                <img src={icon_home_top_s} alt='' />
                                : <img src={icon_home_top} alt='' />}
                        </span>

                    </li>
                    <li onMouseEnter={e => {
                        //console.log(e.nativeEvent);
                        e.nativeEvent.stopImmediatePropagation();
                        e.nativeEvent.preventDefault();
                        if (e.nativeEvent && e.nativeEvent.stopPropagation) {
                            //因此它支持W3C的stopPropagation()方法 
                            e.nativeEvent.stopPropagation();
                        } else {
                            //否则，我们需要使用IE的方式来取消事件冒泡 
                            window.event.cancelBubble = true;
                        }
                        this.setState({ call_hover: true })
                    }} onMouseLeave={() => {
                        this.setState({ call_hover: false })
                    }}>
                        <span>{this.state.call_hover ?
                            <img src={icon_home_call_s} alt='' />
                            : <img src={icon_home_call} alt='' />}</span>
                        <div
                        style={{height:80}}
                            className={`${this.state.call_hover ? 'hover w300' : ''}`}>
                            <div>
                            

                                <p>您的数字化转型专家</p>
                                <p style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis',height:40,width:188}}>吴先生  15913358178 <br/> 罗先生 13590283227</p>
                            </div>
                        </div>
                    </li>
                    <li onMouseEnter={() => {
                        this.setState({ email_hover: true })
                    }} onMouseLeave={() => {
                        this.setState({ email_hover: false })
                    }}>
                        <span>{this.state.email_hover ?
                            <img src={icon_home_message_s} alt='' />
                            : <img src={icon_home_message_n} alt='' />}</span>
                        <div className={`${this.state.email_hover ? 'hover' : ''}`}>
                            <div><p>邮件咨询</p>
                                <p>cloud@colourlife.com</p></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div >)
    }
}


// WEBPACK FOOTER //
// ./src/api/common.jsx